module.exports = __webpack_public_path__ + "static/img/middle.b86799c.png";


//////////////////
// WEBPACK FOOTER
// ./static/middle.png
// module id = 9kem
// module chunks = 1